import { useAppDispatch } from "features/config/hooks";
import React from "react";
import { MaterialInput } from "features/shared/presentation/components";

interface StockOrderHandleQuantityProps {
  setNewCurrentValue: (newVal: number) => void;
  currentValue: number | null;
  maxQuantity?: number;
}

export function StockOrderHandleQuantity(props: StockOrderHandleQuantityProps) {
  const { maxQuantity = 9999, currentValue = 0, setNewCurrentValue } = props;

  const handleQuantityButtonChange = (event: {
    currentTarget: { id: string };
  }) => {
    let value = currentValue || 0;

    if (maxQuantity && value < maxQuantity) {
      if (event.currentTarget.id === "plus") {
        const plusVal = value + 1;
        value = plusVal < maxQuantity ? plusVal : maxQuantity;
      }
    }

    if (event.currentTarget.id === "minus") {
      const minusVal = value - 1;
      value = minusVal > 0 ? minusVal : 0;
    }

    setNewCurrentValue(value);
  };

  const handleQuantityTextChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    // remove commas and non-digits
    let value = event.target.value.replace(/,/g, "").replace(/\D/g, "");

    if (maxQuantity && Number(value) > maxQuantity) {
      value = maxQuantity.toString();
    }

    setNewCurrentValue(Number(value));
  };

  // format with commas for display
  const formattedValue =
    currentValue && currentValue > 0
      ? currentValue.toLocaleString("en-US")
      : "";

  return (
    <div className="text-xs flex space-x-1 justify-end">
      <MaterialInput
        required
        type="text"
        value={formattedValue}
        onChange={handleQuantityTextChange}
        autoComplete="off"
        size="small"
        placeholder="0"
        colorTheme="black"
        name="quantityTextChange"
        inputProps={{ maxLength: maxQuantity ? 8 : 4 }}
        sx={{
          "& .MuiInputBase-input": {
            width: `${Math.max(formattedValue.length || 1, 1)}ch`,
            minWidth: "4ch",
          },
        }}
      />

      <div className="flex flex-col text-white font-semibold justify-between space-y-0.5">
        <button
          className="bg-primary rounded-t-sm w-7 h-fit py-0.5"
          id="plus"
          onClick={handleQuantityButtonChange}
        >
          +
        </button>
        <button
          className="bg-primary rounded-b-sm w-7 h-fit py-0.5"
          id="minus"
          onClick={handleQuantityButtonChange}
        >
          -
        </button>
      </div>
    </div>
  );
}
